import config from '@/config';
import axios from '@/utils/axios';
import { UserInfo } from './types';

/**
 * 登录
 */
export const signIn = (data: {
  userName: string;
  password: string;
}): Promise<{
  status: string;
  data: {
    accessToken: string;
  };
}> => {
  return axios.post(`${config.apiRoot}/user/auth/sso-login`, data);
};

/**
 * 获取当前登录状态
 */
export const getUserInfo = (
  accessToken?: string
): Promise<{
  status: string;
  data: UserInfo;
}> => {
  const level = localStorage.getItem('accessToken');
  if (level !== '0' && level !== '1' && level !== '2' && level !== '4') {
    return Promise.reject();
  }

  // @ts-ignore
  return axios
    .get(
      `${config.apiRoot}/user/auth/user-info`,
      accessToken
        ? {
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        : {}
    )
    .then((result) => ({
      ...result,
      data: {
        ...result.data,
        level,
      },
    }));
};
